module.exports = __webpack_public_path__ + "static/img/chuzhongshuxue6.ebda83ce.jpg";